import { WebWrapper } from '../../components/WebWrapper'

import { FollowList, FollowListProp } from './FollowList'

export default (props: FollowListProp) => (
  <WebWrapper>
    <FollowList {...props} />
  </WebWrapper>
)
